module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 86);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"icon__container___xqcIR alignItems-center display-flex flexDirection-row justifyContent-center pinAll position-absolute","icon":"icon__icon___1MTB1 display-flex fill-smoke--xd"};

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Loader;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _color = __webpack_require__(6);

var _color2 = _interopRequireDefault(_color);

var _general = __webpack_require__(7);

var _general2 = _interopRequireDefault(_general);

var _sizes = __webpack_require__(8);

var _sizes2 = _interopRequireDefault(_sizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_extends({}, _color2.default, _general2.default));

function Loader(_ref) {
  var size = _ref.size,
      color = _ref.color;

  var smallBorder = size === 'extraSmall' || size === 'small';

  var className = cx('loader', color);

  var style = {
    width: _sizes2.default[size],
    height: _sizes2.default[size],
    borderWidth: smallBorder ? 1 : 2
  };

  return _react2.default.createElement('div', { className: className, style: style });
}

Loader.propTypes = {
  size: _propTypes2.default.oneOf(Object.keys(_sizes2.default)),
  color: _propTypes2.default.oneOf(Object.keys(_color2.default))
};

Loader.defaultProps = {
  size: 'medium',
  color: 'silver'
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"white":"color__white___1SJ9j borderColor-white borderRightColor-transparent","smoke":"color__smoke___35Of1 borderColor-smoke borderRightColor-transparent","darkSmoke":"color__darkSmoke___j493w borderColor-smoke--d borderRightColor-transparent","silver":"color__silver___2GAUx borderColor-silver borderRightColor-transparent","blue":"color__blue___3N6dr borderColor-blue borderRightColor-transparent"};

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"general__loader___2CseQ animation-spin borderRadius-circle borderStyle-solid display-block transitionDuration-m transitionProperty-opacity transitionTimingFunction-ease-in-out"};

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loaderSize = {
  extraLarge: 22,
  large: 14,
  medium: 14,
  small: 8,
  extraSmall: 6
};

exports.default = loaderSize;

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Avatar = __webpack_require__(87);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Avatar;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _Loader = __webpack_require__(5);

var _Loader2 = _interopRequireDefault(_Loader);

var _Image = __webpack_require__(88);

var _Image2 = _interopRequireDefault(_Image);

var _User = __webpack_require__(89);

var _User2 = _interopRequireDefault(_User);

var _border = __webpack_require__(90);

var _border2 = _interopRequireDefault(_border);

var _general = __webpack_require__(91);

var _general2 = _interopRequireDefault(_general);

var _shape = __webpack_require__(92);

var _shape2 = _interopRequireDefault(_shape);

var _size = __webpack_require__(93);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var avatarBorders = Object.keys(_border2.default);
var avatarSizes = Object.keys(_size2.default);

var styles = _extends({}, _border2.default, _general2.default, _shape2.default, _size2.default);

var imagePlaceholder = {
  person: _react2.default.createElement(_User2.default, null),
  picture: _react2.default.createElement(_Image2.default, null)
};

/**
 * Avatars display an image if the user has uploaded one but if not, initials
 * are shown instead. The background color is chosen randomly for each user and
 * set inline with the `color` prop. Additionally, if there are no initials
 * stored, there are two placeholder icons to choose from.
 */
function Avatar(_ref) {
  var borderColor = _ref.borderColor,
      boxShadow = _ref.boxShadow,
      color = _ref.color,
      defaultImage = _ref.defaultImage,
      image = _ref.image,
      initials = _ref.initials,
      isLoading = _ref.isLoading,
      shape = _ref.shape,
      size = _ref.size,
      teamImage = _ref.teamImage;

  var cx = _bind2.default.bind(styles);

  var emptyAvatarBorder = cx(borderColor, {
    avatarBorder: borderColor
  });

  var avatarProps = {
    className: cx('avatar', [image ? null : emptyAvatarBorder], shape, size, _defineProperty({}, styles.avatarShadow, boxShadow)),
    title: initials,
    style: { backgroundColor: color }
  };

  var imgProps = {
    className: cx('avatarImg', borderColor, shape, {
      avatarBorder: borderColor
    }),
    style: { backgroundImage: 'url(' + image + ')' }
  };

  var initialProps = {
    className: cx('avatarInitials')
  };

  var teamProps = {
    className: cx('avatarTeam', 'team--' + size, borderColor, {
      avatarBorder: borderColor
    }),
    style: { backgroundImage: 'url(' + teamImage + ')' }
  };

  var loaderSize = void 0;

  if (size === 'xl' || size === 'l') {
    loaderSize = 'extraLarge';
  } else if (size === 'xs' || size === 'xxs') {
    loaderSize = 'extraSmall';
  } else {
    loaderSize = 'medium';
  }

  var teamComponent = teamImage ? _react2.default.createElement('div', teamProps) : null;
  var placeholderComponent = initials ? null : imagePlaceholder[defaultImage];
  var imageComponent = image ? _react2.default.createElement('div', imgProps) : placeholderComponent;

  return _react2.default.createElement(
    'div',
    avatarProps,
    isLoading ? _react2.default.createElement(
      'div',
      { className: styles.loader },
      _react2.default.createElement(_Loader2.default, { size: loaderSize })
    ) : _react2.default.createElement(
      'span',
      null,
      imageComponent,
      _react2.default.createElement(
        'div',
        initialProps,
        initials
      ),
      teamComponent
    )
  );
}

Avatar.propTypes = {
  /** Hex value to be used with `initials` when there's no `image` */
  borderColor: _propTypes2.default.oneOf(avatarBorders),
  boxShadow: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  defaultImage: _propTypes2.default.oneOf(Object.keys(imagePlaceholder)),
  /** URL for the user's avatar */
  image: _propTypes2.default.string,
  /** Two characters to be used with `color` when there's no `image` */
  initials: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool,
  shape: _propTypes2.default.oneOf(['circle', 'square']).isRequired,
  size: _propTypes2.default.oneOf(avatarSizes).isRequired,
  /** URL for the optional team badge */
  teamImage: _propTypes2.default.string
};

Avatar.defaultProps = {
  boxShadow: false,
  defaultImage: 'picture',
  initials: '',
  isLoading: false,
  shape: 'circle',
  size: 'm'
};

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Image;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(39);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Image() {
  return _react2.default.createElement(
    'div',
    { className: _icon2.default.container },
    _react2.default.createElement(
      'svg',
      {
        className: _icon2.default.icon,
        width: '40',
        height: '36',
        viewBox: '0 0 40 36'
      },
      _react2.default.createElement('path', { d: 'M39.5,1.94A2.08,2.08,0,0,1,40,3.3V32.66A2,2,0,0,1,39.5,34a2,2,0,0,1-1.21.71A128.29,128.29,0,0,1,20,36,128.29,128.29,0,0,1,1.71,34.71,2,2,0,0,1,.5,34,2,2,0,0,1,0,32.66V3.3A2.08,2.08,0,0,1,.5,1.94a1.81,1.81,0,0,1,1.21-.69A130.14,130.14,0,0,1,20,0,129.56,129.56,0,0,1,38.29,1.25,1.81,1.81,0,0,1,39.5,1.94ZM36,29.25V5A126.26,126.26,0,0,0,20.13,4,133.67,133.67,0,0,0,4,5V29.6l3.71.4,16.87-9.48a3,3,0,0,1,1.58-.4,3.16,3.16,0,0,1,2.42,1ZM14.83,15.83A3.86,3.86,0,0,1,12,17a4,4,0,0,1-4-4,4,4,0,0,1,4-4,4,4,0,0,1,4,4A3.86,3.86,0,0,1,14.83,15.83Z' })
    )
  );
}

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = User;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(39);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function User() {
  return _react2.default.createElement(
    'div',
    { className: _icon2.default.container },
    _react2.default.createElement(
      'svg',
      {
        className: _icon2.default.icon,
        width: '40',
        height: '40',
        viewBox: '0 0 40 40'
      },
      _react2.default.createElement('path', { d: 'M38.8,38.62l-.54.11-.85.17q-.49.11-1.23.22t-1.59.19A130.42,130.42,0,0,1,20,40Q6.92,40,1,38.58A1.49,1.49,0,0,1,.2,38a1.26,1.26,0,0,1-.16-1,10.72,10.72,0,0,1,2.19-4.7,16.81,16.81,0,0,1,4.2-3.45A27.58,27.58,0,0,1,9.6,27.37q1.43-.56,2.23-.91a8.45,8.45,0,0,0,1.72-1A3.29,3.29,0,0,0,14.73,24,4.59,4.59,0,0,0,14,19.74Q8.28,11,11.95,5a10.06,10.06,0,0,1,3.66-3.64A7.89,7.89,0,0,1,20,0a8,8,0,0,1,4.44,1.31A10.47,10.47,0,0,1,28.13,5q3.66,6-2,14.78a5,5,0,0,0-.9,4.27,3.34,3.34,0,0,0,1.65,1.81,24.56,24.56,0,0,0,3.53,1.55q2.28.95,3.13,1.42a16.81,16.81,0,0,1,4.2,3.45A10.72,10.72,0,0,1,40,36.94a1.26,1.26,0,0,1-.16,1,1.49,1.49,0,0,1-.83.63Z' })
    )
  );
}

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"white":"border__white___EAfB7 borderColor-white","snow":"border__snow___1PJAy borderColor-snow","smoke":"border__smoke___3ngaW borderColor-smoke","black":"border__black___2dRHl borderColor-black"};

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"avatar":"general__avatar___3uXPO position-relative bg-snow--d","avatarBorder":"general__avatarBorder___2sGuz borderStyle-solid","avatarImg":"general__avatarImg___1MHGu backgroundPosition-centerCenter backgroundRepeat-noRepeat backgroundSize-cover position-absolute transitionDuration-l transitionProperty-opacity transitionTimingFunction-ease-in-out","avatarInitials":"general__avatarInitials___iWD44 c-white textAlign-center textTransform-uppercase width-100","avatarTeam":"general__avatarTeam___kygP5 backgroundRepeat-noRepeat backgroundSize-cover borderRadius-circle boxSizing-contentBox position-absolute","team--xl":"general__team--xl___7AAgx","team--l":"general__team--l___1CWmz","team--m":"general__team--m___2D3Cr","team--s":"general__team--s___3E7gf","team--xs":"general__team--xs___21uVW","team--xxs":"general__team--xxs___lQTZS","loader":"general__loader___2S06C pinCenter position-absolute","avatarShadow":"general__avatarShadow___K4oG2"};

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"circle":"shape__circle___28iy2 borderRadius-circle","square":"shape__square___2WAsk borderRadius-l"};

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"xl":"size__xl___RzYKt fontSize-xxl","l":"size__l___2xqeU fontSize-xxl","m":"size__m___3J0XU fontSize-l","s":"size__s___1SgIa fontSize-m","xs":"size__xs___5hYN4 fontSize-xs","xxs":"size__xxs___2_2Bc fontSize-xxs"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-avatar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-avatar.js
// module id = 518
// module chunks = 63239383231690 157636680307020